<template>
  <div>
    <vs-button color="secondary" @click="showPopup = true">{{ label }}</vs-button>
    <popup-load-prev-board
      title="안전작업허가서"
      :setBoardId="845"
      v-model="showPopup"
      :setConditions="setConditions"
      @selectRowData="selectRowData" />
  </div>
</template>

<script>
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";

export default {
  name: "Select845Button",
  components: {PopupLoadPrevBoard},
  props: {
    label: {
      type: String,
      default: '안전작업허가서 정보 불러오기'
    }
  },
  data () {
    return {
      showPopup: false
    }
  },
  methods: {
    selectRowData (data) {
      this.showPopup = false
      this.$emit('select', data)
    },
    setConditions (nav, conditions) {

      conditions.push({
        key: 'body.안전작업허가서정보.작업기간.eDate',
        operator: '>=',
        value: new Date().format('yyyy-MM-dd')
      })

      return conditions
    }
  },
}
</script>

<style scoped>

</style>
